module.exports = __webpack_public_path__ + "static/nodes-741290069aceb3f1eef1d716d05e1e2b.png";